<template>
    <div class="banner">
<!--        <swiper :options="swiperOptiona" ref="mySwipers" class="swiper"  v-if="bList.length>0">-->
<!--            <swiper-slide class="item" v-for="(item,index) in bList" :key="index">-->
<!--               <img class="bgImg" :src="`http://www.shipgroup.com.cn/${item.picurl}`" alt="">-->
<!--                <div class="text">-->
<!--                    <p class="t1">{{item.title}}</p>-->
<!--                    <p class="t2">{{item.description}}</p>-->
<!--                    <div>-->
<!--                        <img src="../assets/yizhou/play.png" alt="">-->
<!--                    </div>-->
<!--                </div>-->
<!--            </swiper-slide>-->
<!--        </swiper>-->

        <div class="allImgs">
            <div class="item" :class="{active:isActive}" >
                <img class="bgImg" :src="`http://www.shipgroup.com.cn/${info.picurl}`" alt="">
                <div class="text">
                    <p class="t1">{{info.title}}</p>
                    <p class="t2">{{info.description}}</p>
                    <div>
                        <img src="../assets/yizhou/play.png" alt="">
                    </div>
                    <a :href="info.linkurl" target="_blank">
                        <svg>
                            <rect x="0" y="0" fill="none" width="100%" height="100%"></rect>
                        </svg>
                        Learn more
                    </a>
                </div>
            </div>
        </div>

        <div class="lines">
            <div class="la">

            </div>
            <swiper :options="swiperOption2" ref="mySwipers2" class="swiper2" v-if="bList.length>0">
                <swiper-slide class="item" v-for="(item,index) in bList" :key="index" :class="{active:select===index}">
                    <div class="one" @click="change(index,item)">
                        <div class="l">
                            <img class="bgImg" :src="`http://www.shipgroup.com.cn/${item.img}`" alt="">
                        </div>
                        <p>{{item.type}}</p>
                        <div class="intro">
                            {{item.intro}}
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <div class="ra">

            </div>
        </div>


        <div class="swiper-pagination"></div>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import { getProductsUrl} from '../util/lang'
    import '../common/jquery-1.11.3.min'
    export default {
        name: "banner",
        data(){
            let _this=this
            return{
                isActive:false,
                select:0,
                bList:[],
                info:{},
                swiperOptiona:{
                    pagination: {
                        el: ".banner .swiper-pagination",
                        clickable: true,
                        renderBullet: function(index, className) {
                            return '<span class="' + className + '"><i></i></span>';
                        }
                    },
                    notNextTick: true,
                    slidesPerView:1,//一行显示3个
                    speed:1000,
                    init:false,
                    loop:true,
                    effect:'fade',
                    fadeEffect:{
                      crossFade: true
                    },
                    setWrapperSize :true,
                    autoplay: false,
                    on: {
                        slideChangeTransitionEnd: () => {
                            this.$nextTick(() => {
                                let swiper = _this.$refs.mySwipers.swiper;
                                let active = swiper.realIndex;
                                let previousIndex = swiper.previousIndex;
                                let bullets = swiper.pagination.bullets;
                                let bulletsArray = Array.from(bullets);
                                for (let i = 0; i < bulletsArray.length; i++) {
                                    $('.banner .swiper-pagination .swiper-pagination-bullet').eq(i).children('i').stop().width("0%")
                                }
                                for (let i = 0; i < active; i++) {
                                    $('.banner .swiper-pagination .swiper-pagination-bullet').eq(i).children('i').stop().width("100%")
                                }
                                $('.banner .swiper-pagination .swiper-pagination-bullet').eq(active).children('i').stop().animate({width: '100%'}, 5000, "linear")

                            });
                        }
                    }
                },
                swiperOption2:{
                    notNextTick: true,
                    slidesPerView:3,//一行显示3个
                    slideToClickedSlide: true,
                    speed:1000,
                    init:false,
                    loop:false,
                    setWrapperSize :true,
                    autoplay:  false,
                    breakpoints:{
                        1000:{
                            slidesPerView:1
                        }
                    }
                },
            }
        },
        components: {
            swiper,
            swiperSlide,
        },
        mounted(){
            this.$nextTick(()=>{
                this.getList('1')
            })
        },
        methods:{
            change(index,n){
                this.select=index
                this.isActive=false
                 setTimeout(()=>{
                     this.isActive=true
                     this.info=n
                 },1000)
            },
            getList(id){
                const url = `${getProductsUrl(id)}`
                this.$axios.get(url).then(res => {
                    this.bList=res.data.data
                    this.info=res.data.data[0]
                    setTimeout(()=>{
                        // this.$refs.mySwipers.swiper.init()
                        this.$refs.mySwipers2.swiper.init()
                        this.isActive=true
                        // const swiperTop = this.$refs.mySwipers.swiper
                        // const swiperThumbs = this.$refs.mySwipers2.swiper
                        // swiperTop.controller.control = swiperThumbs
                        // swiperThumbs.controller.control = swiperTop
                    },100)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .banner{
        width:100%;
        height:100vh;
        position: relative;
        .allImgs{
            width:100%;
            height:100vh;
            .item{
                position: relative;
                overflow: hidden;
                width:100%;
                height:100%;
                .bgImg{
                    width:100%;
                    height:100%;
                    object-fit: cover;
                    display: block;
                    z-index: 1;
                    cursor: pointer;
                    transition: all 3s;
                }
                .text{
                    z-index: 10;
                    position: absolute;
                    left: 10%;
                    top:40%;
                    width:80%;
                    p{
                        color:white;
                        transition: all 600ms;
                        /*animation: tshow 1s forwards linear;*/
                    }
                    .t1{
                        font-family: "SOURCEHANSANSCN-BOLD";
                        font-size: 62px;
                        transition-delay: 500ms;
                        visibility: hidden;
                        opacity: 0;
                        transform: translate(0%, 50%) matrix(1, 0, 0, 1, 0, 0);
                    }
                    .t2{
                        font-size: 20px;
                        font-family: "armt";
                        margin-top: 10px;
                        font-weight: lighter;
                        transition-delay: 700ms;
                        visibility: hidden;
                        opacity: 0;
                        transform: translate(0%, 50%) matrix(1, 0, 0, 1, 0, 0);
                    }
                    div{
                        margin: 30px auto;
                        cursor: pointer;
                    }
                    a{
                        color: #fff;
                        cursor: pointer;
                        display: block;
                        font-size: 14px;
                        line-height: 45px;
                        max-width: 160px;
                        position: relative;
                        text-decoration: none;
                        text-transform: uppercase;
                        vertical-align: middle;
                        width: 100%;
                        text-align: center;
                        transition-delay: 900ms;
                        visibility: hidden;
                        opacity: 0;
                        transform: translate(0%, 50%) matrix(1, 0, 0, 1, 0, 0);
                        svg{
                            height: 45px;
                            left: 0;
                            position: absolute;
                            top: 0;
                            width: 100%;
                            rect{
                                fill: none;
                                stroke: rgba(255,255,255,.5);
                                stroke-width: 2;
                                stroke-dasharray: 422, 0;
                            }
                        }
                        &:hover{
                            svg{
                                rect{
                                    stroke-width: 5;
                                    stroke-dasharray: 15, 310;
                                    stroke-dashoffset: 48;
                                    -webkit-transition: all 1.35s cubic-bezier(0.19, 1, 0.22, 1);
                                    transition: all 1.35s cubic-bezier(0.19, 1, 0.22, 1);
                                }
                            }
                        }
                    }
                }
                /*@keyframes tshow {*/
                /*    from{*/
                /*        visibility: hidden;*/
                /*        opacity: 0;*/
                /*        transform: translate(0%, 50%) matrix(1, 0, 0, 1, 0, 0);*/
                /*    }*/
                /*    to{*/

                /*    }*/
                /*}*/
            }
            .active{
                 .bgImg{
                     opacity: 1;
                     transform: scale(1.05);
                 }
                .text{
                    .t1{
                        visibility: inherit;
                        opacity: 1;
                        transform: matrix(1, 0, 0, 1, 0, 0);
                    }
                    .t2{
                        visibility: inherit;
                        opacity: 1;
                        transform: matrix(1, 0, 0, 1, 0, 0);
                    }
                    a{
                        visibility: inherit;
                        opacity: 1;
                        transform: matrix(1, 0, 0, 1, 0, 0);
                    }
                    @keyframes showt {
                        from{
                            opacity: 0;
                            transform: translate(0%, 50%) matrix(1, 0, 0, 1, 0, 0);
                        }
                        to{
                            opacity: 1;
                            transform: matrix(1, 0, 0, 1, 0, 0);
                        }
                    }
                }
            }
        }
        /*.swiper{*/
        /*    height:100%;*/
        /*    .item{*/
        /*        position: relative;*/
        /*        overflow: hidden;*/
        /*        .bgImg{*/
        /*            width:100%;*/
        /*            height:100%;*/
        /*            object-fit: cover;*/
        /*            display: block;*/
        /*            z-index: 1;*/
        /*            cursor: pointer;*/
        /*            transition: all 3s;*/
        /*        }*/
        /*        .text{*/
        /*            z-index: 10;*/
        /*            position: absolute;*/
        /*            left: 10%;*/
        /*            top:40%;*/
        /*            width:80%;*/
        /*            p{*/
        /*                color:white;*/
        /*                transition: all 1s;*/
        /*                visibility: hidden;*/
        /*                opacity: 0;*/
        /*                transform: translate(0%, 50%) matrix(1, 0, 0, 1, 0, 0);*/
        /*            }*/
        /*            .t1{*/
        /*                font-family: "SOURCEHANSANSCN-BOLD";*/
        /*                font-size: 62px;*/
        /*                transition-delay: 500ms;*/
        /*            }*/
        /*            .t2{*/
        /*                font-size: 20px;*/
        /*                font-family: "armt";*/
        /*                margin-top: 10px;*/
        /*                transition-delay: 700ms;*/
        /*                font-weight: lighter;*/
        /*            }*/
        /*            div{*/
        /*                margin: 30px auto;*/
        /*                cursor: pointer;*/
        /*            }*/
        /*        }*/
        /*    }*/
        /*    .swiper-slide-active{*/
        /*        .text{*/
        /*            p{*/
        /*                visibility: inherit; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);*/
        /*            }*/
        /*        }*/
        /*    }*/
        /*}*/
        .lines{
            position: absolute;
            bottom:5%;
            left:0;
            width:100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            z-index: 1000;
            .la,.ra{
                width:30%;
                height:1px;
                background-color: rgba(255,255,255,.2);
                position: relative;
            }
            .la{
                &::after{
                    content:'';
                    display: inline-block;
                    height:5px;
                    width:5px;
                    border-radius: 50%;
                    background-color: white;
                    position: absolute;
                    right:0;
                    top:-2px;
                }
            }
            .ra{
                &::before{
                    content:'';
                    display: inline-block;
                    height:5px;
                    width:5px;
                    border-radius: 50%;
                    background-color: white;
                    position: absolute;
                    left:0;
                    top:-2px;
                }
            }
            .swiper2{
                width:40%;
                margin: 0 auto;
                .item{
                    cursor: pointer;
                    background-color: rgba(255,255,255,.2);
                    transition: all 600ms;
                    position: relative;
                    &::before{
                        content: "";
                        width: 100%;
                        background-color:#000E27;
                        position: absolute;
                        left: 0;
                        top:0;
                        height:100%;
                        transform-origin: 100%;
                        -webkit-transform-origin: 100%;
                        -webkit-transition: -webkit-transform .4s cubic-bezier(.4,0,.2,1);
                        transition: transform .4s cubic-bezier(.4,0,.2,1);
                        -webkit-transform: scaleX(0);
                        visibility: hidden\9;
                        z-index: -1;
                    }
                    &:hover::before{
                        transform: scaleX(1);
                        -webkit-transform: scaleX(1);
                        -moz-transform: scaleX(1);
                        transform-origin: 0;
                        -webkit-transform-origin: 0;
                        visibility: visible\9;
                    }
                    .one{
                        width:100%;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        padding: 20px 0;
                        align-items: center;
                        height:100%;
                        margin: 0 auto;
                        z-index: 1000;
                        position: relative;
                        .l{
                            height:55px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            transition: all 600ms;
                        }
                        p{
                            color:white;
                            font-size: 18px;
                            font-family: "SourceHanSansSC-Normal";
                            margin-left: 10px;
                            transition: all 600ms;
                        }
                        .intro{
                            position: absolute;
                            left:0;
                            top:0;
                            width:100%;
                            height:100%;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            color:white;
                            transition: all 600ms;
                            z-index: 10000;
                            opacity: 0;
                            transform: translateY(-80px);
                        }
                    }
                    &:hover{
                        /*background-color: transparent;*/
                        .one{
                            .l,p{
                                opacity: 0;
                                transform: translateY(80px);
                            }
                            .intro{
                                opacity: 1;
                                transform: translateY(0);
                            }
                        }
                    }
                }
                .swiper-slide-active{
                    position: relative;
                    &::after{
                        content:'';
                        display: inline-block;
                        height:100%;
                        width:1px;
                        background-color: rgba(255,255,255,.2);
                        position: absolute;
                        right:0;
                        top:0;
                    }
                }
                /*.active{*/
                /*    &::before{*/
                /*        transform: scaleX(1);*/
                /*        -webkit-transform: scaleX(1);*/
                /*        -moz-transform: scaleX(1);*/
                /*        transform-origin: 0;*/
                /*        -webkit-transform-origin: 0;*/
                /*        visibility: visible\9;*/
                /*    }*/
                /*    background-color: transparent;*/
                /*    .one{*/
                /*        .l,p{*/
                /*            opacity: 0;*/
                /*            transform: translateY(80px);*/
                /*        }*/
                /*        .intro{*/
                /*            opacity: 1;*/
                /*            transform: translateY(0);*/
                /*        }*/
                /*    }*/
                /*}*/
            }
        }
        .btns{
            position: absolute;
            right:0;
            bottom:60px;
            width:349px;
            height:89px;
            z-index: 1000000;
            .prev{
                position: absolute;
                cursor: pointer;
                z-index: 1000;
                left:20px;
                transform: rotateY(180deg);
                top:33px;
                i{
                    color:white;
                    transition: all 600ms;
                }
                &:hover{
                    i{
                        color:#FFCB06;
                    }
                }
            }
            .next{
                position: absolute;
                cursor: pointer;
                z-index: 1000;
                right:20px;
                top:33px;
                i{
                    color:white;
                    transition: all 600ms;
                }
                &:hover{
                    i{
                        color:#FFCB06;
                    }
                }
            }
            .btn:focus{
                outline: none;
            }
        }
        @media screen and (max-width: 1440px) and (min-width: 1000px){
            .swiper{
            }
        }
        @media screen and (max-width: 1000px){
            .swiper{
                .item{
                    .text{
                        left:5%;
                        width:90%;
                        .cn{
                            p:nth-child(1){
                                font-size: 20px;
                            }
                            p:nth-child(2){
                                font-size: 22px;
                            }
                        }
                        .en{
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width:1000px) {
        .banner{
            .allImgs{
                .item{
                    .text{
                        .t1{
                            font-size: 23px;
                        }
                        .t2{
                            font-size: 16px;
                            line-height: 30px;
                            height: 60px;
                        }
                    }
                }
            }
            .lines{
                bottom: 0;
                .la,.ra{
                    display: none;
                }
                .swiper2{
                    width: 100%;
                }
            }
        }
    }
</style>
<style scoped>
    .banner .swiper-pagination {
        bottom: 18%;
        width: 100%;
        left:0;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet {
        position: relative;
        width: 50px;
        height: 1px;
        opacity: 0.6;
        margin: 0 15px;
        background-color: rgba(255,255,255,.2);
        border-radius: 0;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet i{
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;
        background-color: #fff;
        opacity:1;
    }
</style>
